// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__fvqaJ","footerWrap":"Footer_footerWrap__omY3P"};